"use strict";
console.log('Tradestone');
// Menu
jQuery('#menu-button').on('click', e => {
    e.preventDefault();
    e.stopPropagation();
    jQuery('.top-bar-right').toggleClass('open');
});
document.addEventListener('DOMContentLoaded', () => {
    // Highlight current menu item for product pages
    if (window.location.href.indexOf('/products') > -1) {
        document.querySelectorAll('#menu-navigation a').forEach(link => {
            if (link.href.indexOf('/products') > -1) {
                const parentLi = link.closest('li');
                if (parentLi) {
                    parentLi.classList.add('current-menu-item');
                }
            }
        });
    }
    // Search for any images with missing alt tags and apply a default
    setTimeout(() => {
        document.querySelectorAll('img').forEach(img => {
            if (!img.alt) {
                img.alt = '';
            }
        });
    }, 500);
});
